import { createRouter, createWebHistory } from 'vue-router';

// 页面组件导入
import Home from '@/pages/Home.vue';
import About from '@/pages/About.vue';
import Policy from '@/pages/Policy.vue';
import Login from '@/pages/Login.vue';
import Dashboard from '@/pages/Dashboard.vue';

// 路由配置
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false }, // 不需要登录
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { requiresAuth: false }, // 不需要登录
  },
  {
    path: '/policy',
    name: 'Policy',
    component: Policy,
    meta: { requiresAuth: false }, // 不需要登录
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }, // 不需要登录
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }, // 需要登录
  },
];

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守卫 - 预留权限逻辑
router.beforeEach((to, from, next) => {
  const isAuthenticated = false; // 模拟未登录状态，未来可接入登录逻辑
  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log('未登录，跳转到登录页'); // 未来可跳转到登录页面
    next({ path: '/' }); // 默认跳回首页
  } else {
    next();
  }
});

export default router;
